import { fetchGet, fetchPost } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

export const fetchStatesService = (bearerToken: string) =>
  fetchGet(`${apiUri}/xosimage/states`, bearerToken);

export const searchBankruptcyService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/bankruptcy/search`, body, bearerToken);
